// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  width: 100%;
  background: rgba(17, 69, 77, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 2px solid var(--primary-teal-active);
  padding: 1.2rem 0;
  margin-bottom: 2.5rem;
  box-shadow: 0 4px 16px rgba(17, 69, 77, 0.15);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.nav-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  padding: 0.6rem 1.3rem;
  border-radius: 10px;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.95rem;
  position: relative;
  overflow: hidden;
}

.nav-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(95, 184, 165, 0.2), transparent);
  transition: left 0.5s ease;
}

.nav-link:hover::before {
  left: 100%;
}

.nav-link:hover {
  background-color: rgba(95, 184, 165, 0.15);
  color: var(--accent-mint);
  transform: translateY(-2px);
}

.nav-link.active {
  background: linear-gradient(135deg, var(--primary-teal-light) 0%, var(--primary-teal-active) 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(42, 141, 156, 0.3);
}

.nav-link.active:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(42, 141, 156, 0.4);
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mDAAmD;EACnD,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kGAAkG;EAClG,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD","sourcesContent":[".navigation {\n  width: 100%;\n  background: rgba(17, 69, 77, 0.9);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border-bottom: 2px solid var(--primary-teal-active);\n  padding: 1.2rem 0;\n  margin-bottom: 2.5rem;\n  box-shadow: 0 4px 16px rgba(17, 69, 77, 0.15);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.nav-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.nav-links {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.nav-link {\n  color: rgba(255, 255, 255, 0.9);\n  text-decoration: none;\n  padding: 0.6rem 1.3rem;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  font-size: 0.95rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.nav-link::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(95, 184, 165, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.nav-link:hover::before {\n  left: 100%;\n}\n\n.nav-link:hover {\n  background-color: rgba(95, 184, 165, 0.15);\n  color: var(--accent-mint);\n  transform: translateY(-2px);\n}\n\n.nav-link.active {\n  background: linear-gradient(135deg, var(--primary-teal-light) 0%, var(--primary-teal-active) 100%);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(42, 141, 156, 0.3);\n}\n\n.nav-link.active:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(42, 141, 156, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
